var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

require('slick-carousel');


module.exports = function() {
    $('.carousel-container .carousel').each(function() {
        // Initialize Carousel
        $(this).slick({
            nextArrow: $(this).find('.js-partial--arrow-right').html(),
            prevArrow: $(this).find('.js-partial--arrow-left').html()
        });
    });
};
